export const USE_SINGLE_DEPARTMENT_QUERY_KEY = "useSingleDepartmentQuery";
export const USE_DEPARTMENT_COLLECTION_QUERY_KEY = "useDepartmentCollectionQuery";
